import classNames from 'classnames';
import { Document } from '@/entities/document';
import { tp } from '@/shared/lib/typograf';
import Button from '../../shared/Button';
import DocumentLink from '../../shared/DocumentLink';
import Link from '../../shared/Link';

export interface AboutSectionProps {
    title: string;
    description: string;
    link?: {
        text: string;
        href: string;
    } | null;
    documents?: Document[] | null;
}

type Props = React.HTMLAttributes<HTMLElement> & {
    aboutSectionProps: AboutSectionProps;
    document?: Document | null;
};

export const SECTION_ID = 'aboutSection';
const AboutSection = ({ aboutSectionProps, document: presentationDocument, ...props }: Props) => {
    return (
        <section
            {...props}
            className={classNames('about__section js-header-theme-trigger', props.className)}
            id={props.id ?? SECTION_ID}
        >
            <div className="about__wrapper wrapper">
                <div className="about__title h2">{tp(aboutSectionProps.title)}</div>
                <div className="about__description text-m wysiwyg">
                    {aboutSectionProps.description && (
                        <div
                            className="about__description-text"
                            dangerouslySetInnerHTML={{ __html: tp(aboutSectionProps.description) }}
                        ></div>
                    )}
                    {aboutSectionProps.link && aboutSectionProps.link.href && (
                        <Button
                            tag={Link}
                            href={aboutSectionProps.link.href}
                            target="_blank"
                            rel="noreferrer nofollow"
                            className="about__description-link"
                            variant="outline-dark"
                        >
                            {aboutSectionProps.link.text}
                        </Button>
                    )}
                    {presentationDocument && (
                        <div className="about__documents">
                            <DocumentLink document={presentationDocument} />
                        </div>
                    )}
                    {aboutSectionProps.documents && aboutSectionProps.documents.length > 0 && (
                        <div className="about__documents">
                            {aboutSectionProps.documents.map((document) => (
                                <DocumentLink document={document} key={document.src} />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
